// import library
import axios from 'axios';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// import files
import { env } from '../env';
import CryptoJS from 'crypto-js';

// variables
const locale = localStorage.getItem('locale');
const baseUrl = env.REACT_APP_API_URL;
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const token = localStorage.getItem('token');
const encrypt = localStorage.getItem('userInfo');
const defaultLanguage = localStorage.getItem('defaultLanguage');
const decryptData = (data) => {
    try {
        const decrypted = CryptoJS.AES.decrypt(data, SECRET_KEY).toString(CryptoJS.enc.Utf8);
        return JSON.parse(decrypted);
    } catch (e) {
        window.location.reload();
    }
};
const headers = {
    "Accept" : "application/json",
    "Content-Type" : "application/json",
    ...(token && { "Authorization" : `Bearer ${token}` })
};
let english = {};
let greek = {};

axios.get(baseUrl+"/api/SystemTranslation/GetSystemTranslationList?module=b2b&language=en", { headers }).then((response) => {
    for(var i=0; i < response.data.length; i++) {
       english[response.data[i].key.toLowerCase()] = response.data[i].defaultvalue;
    }
}).catch((error) => {
    console.log(error);
});

axios.get(baseUrl+"/api/SystemTranslation/GetSystemTranslationList?module=b2b&language=gr", { headers }).then((response) => {
    for(var i=0; i < response.data.length; i++) {
        if(response.data[i].value) {
            greek[response.data[i].key.toLowerCase()] = response.data[i].value;
        } else {
            greek[response.data[i].key.toLowerCase()] = response.data[i].defaultvalue;
        }
    }
}).catch((error) => {
    console.log(error);
});

i18n.use(initReactI18next).init({
    fallbackLng: locale ? locale : 'en',
    lng: locale ? locale : 'en',
    resources: {
        en: {
            translations: english
        },
        gr: {
            translations: greek
        }
    },
    ns: ['translations'],
    defaultNS: 'translations'
});

i18n.languages = ['en', 'gr'];

export default i18n;